import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';


const RecentActivity = () => {
  const activities = [
    {
      id: 1,
      type: 'registration',
      member: 'Sarah Johnson',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150',
      action: 'Novo membro cadastrado',
      timestamp: 'há 2 horas',
      icon: 'UserPlus',
      color: 'text-success'
    },
    {
      id: 2,
      type: 'update',
      member: 'Michael Rodriguez',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
      action: 'Perfil atualizado',
      timestamp: 'há 4 horas',
      icon: 'Edit',
      color: 'text-primary'
    },
    {
      id: 3,
      type: 'registration',
      member: 'Emily Chen',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
      action: 'Novo membro cadastrado',
      timestamp: 'há 6 horas',
      icon: 'UserPlus',
      color: 'text-success'
    },
    {
      id: 4,
      type: 'import',
      member: 'Sistema',
      avatar: null,
      action: 'Importação em massa concluída (25 membros)',
      timestamp: 'há 1 dia',
      icon: 'Upload',
      color: 'text-warning'
    },
    {
      id: 5,
      type: 'update',
      member: 'David Wilson',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
      action: 'Informações de contato atualizadas',
      timestamp: 'há 2 dias',
      icon: 'Edit',
      color: 'text-primary'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Atividade recente</h3>
        <Button variant="ghost" size="sm">
          Ver tudo
        </Button>
      </div>
      <div className="space-y-4">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-center space-x-3 p-3 rounded-md hover:bg-muted contextual-fade">
            <div className="flex-shrink-0">
              {activity?.avatar ? (
                <Image
                  src={activity?.avatar}
                  alt={activity?.member}
                  className="w-10 h-10 rounded-full object-cover"
                />
              ) : (
                <div className="w-10 h-10 bg-muted rounded-full flex items-center justify-center">
                  <Icon name="Settings" size={20} className="text-muted-foreground" />
                </div>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2">
                <Icon name={activity?.icon} size={16} className={activity?.color} />
                <p className="text-sm font-medium text-foreground truncate">
                  {activity?.member}
                </p>
              </div>
              <p className="text-sm text-muted-foreground">{activity?.action}</p>
            </div>
            <div className="flex-shrink-0">
              <p className="text-xs text-muted-foreground">{activity?.timestamp}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;